var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "FilterToggle",
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.filters.query,
                expression: "filters.query",
              },
            ],
            attrs: { type: "hidden" },
            domProps: { value: _vm.filters.query },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.filters, "query", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("FormControlSector", {
            attrs: {
              name: "sectors",
              multiple: true,
              "include-ancestors": false,
            },
            model: {
              value: _vm.filters.sectors,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "sectors", $$v)
              },
              expression: "filters.sectors",
            },
          }),
          _vm._v(" "),
          _c("FormControlMember", {
            attrs: {
              name: "member",
              placeholder: "Select...",
              label: "Member company",
            },
            model: {
              value: _vm.filters.member,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "member", $$v)
              },
              expression: "filters.member",
            },
          }),
          _vm._v(" "),
          _c("FormControlDatepicker", {
            attrs: { name: "fromDate", label: "From date" },
            model: {
              value: _vm.filters.fromDate,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "fromDate", $$v)
              },
              expression: "filters.fromDate",
            },
          }),
          _vm._v(" "),
          _c("FormControlDatepicker", {
            attrs: { name: "toDate", label: "To date" },
            model: {
              value: _vm.filters.toDate,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "toDate", $$v)
              },
              expression: "filters.toDate",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("DocumentsTableHeader", { on: { changeSort: _vm.handleSortChange } }),
      _vm._v(" "),
      _vm.$wait.is("loading_search_documents")
        ? _c(
            "div",
            { staticClass: "loading" },
            [_c("Spinner", { attrs: { height: 40, width: 40 } })],
            1
          )
        : _vm.items && _vm.items.length > 0
        ? _c(
            "div",
            [
              _c(
                "ul",
                { staticClass: "search-results" },
                _vm._l(_vm.items, function (item) {
                  return _c(
                    "li",
                    [_c("DocumentSearchResult", { attrs: { resource: item } })],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("Pagination", {
                ref: "pagination",
                on: { "vuetable-pagination:change-page": _vm.onChangePage },
              }),
            ],
            1
          )
        : _c("div", { staticClass: "no-results" }, [
            _vm._v("\n        No results\n    "),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }